export const REPORT_LAB_STATS_REQUESTED = 'REPORT_LAB_STATS_REQUESTED';
export const REPORT_LAB_STATS_SUCCEED = 'REPORT_LAB_STATS_SUCCEED';
export const REPORT_LAB_STATS_FAILED = 'REPORT_LAB_STATS_FAILED';
